import { render, staticRenderFns } from "./InterviewerRemarks.vue?vue&type=template&id=09ba91aa&scoped=true&"
import script from "./InterviewerRemarks.vue?vue&type=script&lang=js&"
export * from "./InterviewerRemarks.vue?vue&type=script&lang=js&"
import style0 from "./InterviewerRemarks.vue?vue&type=style&index=0&id=09ba91aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ba91aa",
  null
  
)

export default component.exports